import { QuickBooksAccountingOAuthBanner } from "@/components/QuickBooksAccountingOAuthBanner";
import { QuickBooksTimeOAuthBanner } from "@/components/QuickBooksTimeOAuthBanner";
import { WorkspaceAvatarMissingBanner } from "@/components/WorkspaceAvatarMissingBanner";

/** Global reconnect prompts for designated operators/admins — not tied to hub module routes. */
export function HubReconnectBanners() {
  return (
    <>
      <WorkspaceAvatarMissingBanner />
      <QuickBooksTimeOAuthBanner />
      <QuickBooksAccountingOAuthBanner />
    </>
  );
}
